// extracted by mini-css-extract-plugin
module.exports = {"action-delete-evidence-wrapper":"ActionDeleteEvidence_action-delete-evidence-wrapper__1nvO6"};